// material-ui
import logo from 'assets/images/NewLogo.png';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const LogoHeaderMinimal = () => {
  return <img src={logo} alt="Google" width={200} />;
};

export default LogoHeaderMinimal;
